import _typeof from "@babel/runtime/helpers/esm/typeof";
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorWarningModalWrapper from "../error-warning-modal/ErrorWarningModalWrapper";
import ItemAddedModalWrapper from "../item-added-modals/ItemAddedModalWrapper";
var BOPIS_EDD_ModalWrapper = /*#__PURE__*/React.lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../bopis-edd-modal/BOPIS_EDD_ModalWrapper"));
  });
});
var ShopApp = function ShopApp(t0) {
  var $ = _c(9);
  var errorsToExclude = t0.errorsToExclude,
    warningsToInclude = t0.warningsToInclude,
    queryClient = t0.queryClient;
  var t1;
  if ($[0] === Symbol["for"]("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/React.createElement(BOPIS_EDD_ModalWrapper, null);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  var t2;
  if ($[1] !== errorsToExclude || $[2] !== warningsToInclude) {
    t2 = /*#__PURE__*/React.createElement(ErrorWarningModalWrapper, {
      errorsToExclude: errorsToExclude,
      warningsToInclude: warningsToInclude
    });
    $[1] = errorsToExclude;
    $[2] = warningsToInclude;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  var t3;
  var t4;
  if ($[4] === Symbol["for"]("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/React.createElement(ItemAddedModalWrapper, null);
    t4 = /*#__PURE__*/React.createElement("div", {
      "data-version": window.NikeShop.version
    });
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  var t5;
  if ($[6] !== queryClient || $[7] !== t2) {
    t5 = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QueryClientProvider, {
      client: queryClient
    }, t1, t2, t3, t4));
    $[6] = queryClient;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
ShopApp.propTypes = {
  shopInstance: PropTypes.shape({
    store: PropTypes.shape({}),
    version: PropTypes.string
  }),
  language: PropTypes.string,
  errorsToExclude: PropTypes.arrayOf(PropTypes.string),
  warningsToInclude: PropTypes.arrayOf(PropTypes.string),
  queryClient: PropTypes.instanceOf(QueryClient)
};
export default ShopApp;